module.exports = __webpack_public_path__ + "img/iphone-charging-UK-en.de1244cf.webp";